module.exports = __webpack_public_path__ + "img/img39.8edabe08.png";